import styleParams from '../GridGallery/stylesParams';

export default styleParams;
